// extracted by mini-css-extract-plugin
export var callCard = "_sh-0";
export var callMessageButton = "_sh-1";
export var helpIcon = "_sh-3";
export var helpIconContainer = "_sh-4";
export var verticalDivider = "_sh-2";